import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.highlight};
  margin-bottom: 2rem;
`;

const Admin = () => {
  return (
    <Container>
      <Title>Admin Dashboard</Title>
      <p>Admin panel for managing the application.</p>
      <Outlet />
    </Container>
  );
};

export default Admin;
